import { Controller } from "@hotwired/stimulus"

// "Why this price?" on the provider page (docs/provider_search_landing.md, "Provider page"): its frame
// loads the first time it's opened, not with every page view. An answer that isn't the frame hides
// it rather than showing Turbo's "Content missing" in the price card.
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  load() {
    if (this.element.open && !this.frameTarget.getAttribute("src")) this.frameTarget.setAttribute("src", this.urlValue)
  }

  hide(event) {
    event.preventDefault()
    this.element.hidden = true
  }
}
